import { ColorAdjustWorkerQueue } from './color-adjust-worker-queue';

// 静态 URL 让 Next 的两种 bundler 都能构建 worker；不创建组件级线程池。
export const colorAdjustWorker = new ColorAdjustWorkerQueue(() => new Worker(
  new URL('./color-adjust.worker.ts', import.meta.url),
  // Let webpack assign a unique chunk name. A fixed name merged two Next build
  // entries into one worker asset, where the later onmessage handler was broken.
  { type: 'module' },
));
